var collapsible_list_component_rtlignore_default = {
  "ltr": "oKKj2",
  "rtl": "wtreO",
  "iconContainer": "v-nsy",
  "icon": "Pmd7y",
  "isExpanded": "uATLQ",
  "listDimensions": "AMjEg"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
